export * from "ce/reducers/entityReducers/canvasWidgetsStructureReducer";
import { default as CE_canvasWidgetsStructureReducer } from "ce/reducers/entityReducers/canvasWidgetsStructureReducer";
export default CE_canvasWidgetsStructureReducer;
